import React from 'react'

export default function Collapsable ({
  maxHeight = 200,
  gradient = true,
  children
}) {
  const [isActive, setIsActive] = React.useState(false)

  const height = isActive ? 'auto' : maxHeight

  return (
    <div className='relative overflow-hidden w-full' onClick={() => setIsActive(true)} style={{ height: height }}>
      {children}
      {isActive || gradient === false
        ? null
        : (
          <svg className='w-full absolute top-0 left-0' height={height} viewBox='0 0 100 100' preserveAspectRatio='none'>
            <defs>
              <linearGradient id='collapsable-gradient' x1='0%' y1='0%' x2='0%' y2='100%'>
                <stop offset='0%' stopColor='#5C69E0' stopOpacity='0' />
                <stop offset='100%' stopColor='#5C69E0' stopOpacity='1' />
              </linearGradient>
            </defs>
            <rect x='0' y='50%' height='50%' width='100%' fill='url(#collapsable-gradient)' />
          </svg>
          )}
    </div>
  )
}
